module.exports = __webpack_public_path__ + "static/media/rosie.ea730caa.png";